import React from 'react'
import { Strategy } from '@/types'
import { LessonNavigateTo } from '../utils'
import { LessonStrategyParams } from '../types'
import { openURL, resolveStrategyAction } from '@/utils'

export function usePrimaryCTA() {
  const strategies = React.useMemo(() => [
    {
      matches: ({ chapter }) => chapter.primary_cta.type === 'contribute',
      execute: ({ chapter }) => LessonNavigateTo.Contribute(null, chapter.id),
      name: 'contribute',
      shouldNavigate: true,
    },
    {
      matches: ({ chapter }) => chapter.primary_cta.type === 'prompt',
      execute: ({ chapter }) => LessonNavigateTo.Contribute(chapter.primary_cta.prompt, chapter.id),
      name: 'prompt',
      shouldNavigate: true,
    },
    {
      matches: ({ chapter }) => chapter.primary_cta.type === 'lesson',
      execute: ({ chapter }) => LessonNavigateTo.Lesson(chapter.primary_cta.lesson_id),
      name: 'lesson',
    },
    {
      matches: ({ chapter }) => chapter.primary_cta.type === 'external_link',
      execute: ({ chapter }) => openURL(chapter.primary_cta.external_url),
      name: 'external_link',
      shouldNavigate: true,
    },
  ] satisfies Strategy<LessonStrategyParams>[], [])

  const resolve = React.useCallback((params: LessonStrategyParams) => {
    return resolveStrategyAction(params, strategies, 'usePrimaryCTA')
  }, [strategies])

  return { resolve }
}
